// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"AuthContainer_skeletonContainer__1l9pd"};